import { CButton } from "@coreui/react";

const LoadingButton = ({ color, size }) => {
  return (
    <CButton color={color ?? "primary"} size={size ?? ""} disabled>
      <span className="spinner-border spinner-border-sm"></span>&ensp;
      Loading...
    </CButton>
  );
};

export default LoadingButton;
